import { styled } from '@linaria/react';

import { TextMessageWrapper } from '../styles';

export const SextingTextMessageWrapped = styled(TextMessageWrapper)`
	text-shadow: 0 1px 7px var(--color-rose-48-solid);
`;
